import React, { useCallback } from 'react';
import { Image } from '@cian/ui-kit';
import { Link } from 'react-router-dom';

import { IArticlesMainAttributesSchema } from '../../repositories/journal/entities/journal/ArticlesMainAttributesSchema';
import * as s from './MainArticleSimplified.css';

interface IMainArticleSimplified extends Pick<IArticlesMainAttributesSchema, 'title' | 'image'> {
  url: string;
  onClick(e: React.MouseEvent): void;
}

/** Топовая статья на Главной (упрощенный вид) */
export const MainArticleSimplified = ({ image, title, url, onClick }: IMainArticleSimplified) => {
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      onClick(e);
    },
    [onClick],
  );

  return (
    <Link to={url} className={s['wrapper']} title={title} onClick={handleClick}>
      <Image
        alt={title}
        borderRadius={'4px'}
        objectFit="contain"
        preloader
        src={image || ''}
        theme="light"
        title={title}
      />

      <span className={`${s['title']}`}>{title}</span>
    </Link>
  );
};
